/*
 * HeaderGlobalSettings — applies page-specific body classes based on URL.
 *
 * On load, matches the current pathname against URL prefix lists from a shop
 * metafield and toggles body classes accordingly (e.g. top spacing under the
 * header, dark header theme). CSS reacts to these classes.
 *
 * Dependencies:
 *   - snippet: api-header-global-settings.liquid (injects JSON + this script)
 *   - metafield: shop.metafields.custom.header_global_settings (JSON)
 *   - data container: <script id="data-header-global-settings"> holding the JSON
 *
 * Usage:
 *   {% render 'api-header-global-settings' %}
 *
 * Metafield JSON format (each value is a list of URL prefixes; matching is
 * prefix-based after normalizing leading/trailing slashes, "/" matches home only):
 *   {
 *     "pages_with_top_spacing": ["/collections/"],       // -> body.has-top-spacing
 *     "pages_with_dark_header_theme": ["/pages/about"]    // -> body.is-secondary-header-theme
 *   }
 */

class HeaderGlobalSettings {
  constructor() {
    this.currentPage = window.location.pathname

    this.data = this.dataObject;
    if (!this.data) return;

    this.init();
  }

  get dataObject() {
    const dataContainer = document.querySelector("[id='data-header-global-settings']");
    if (!dataContainer) return null;

    const dataStr = dataContainer.textContent.trim();
    if (dataStr == 'null') return null

    return JSON.parse(dataStr)
  }

  isAllowedPage(pages_url) {
    const normalize = (url) => '/' + url.replace(/^\/|\/$/g, '');
    const current = normalize(this.currentPage);

    return pages_url.some(url => {
      const normalizedUrl = normalize(url);

      if (normalizedUrl === '/') return current === '/';

      return current.startsWith(normalizedUrl);
    });
  }

  applyBodyClass(dataKey, className) {
    const pages = this.data[dataKey];
    if (!pages) return;

    if (this.isAllowedPage(pages)) {
      document.body.classList.add(className);
    }
  }

  init() {
    this.applyBodyClass('pages_with_top_spacing', 'has-top-spacing');
    this.applyBodyClass('pages_with_secondary_header_theme', 'has-secondary-header-theme');
  }
}

new HeaderGlobalSettings();